import React, {Component} from 'react';
import BarChart from '../BarChart';
import moment from 'moment';
import './TimeLine.css';

import leftArrow from '../../../../../assets/svg/leftArrow.svg';
import rightArrow from '../../../../../assets/svg/rightArrow.svg';

class TimeLine extends Component{

    constructor(props){
        super(props);

        this.state = {
            selectedTime: this.props.selectedTime,
            prevTime: this.props.prevTime,
            nextTime: this.props.nextTime
        }

    }

    componentDidMount() {
        window.$('.rw-container').css('top', '53px');
        this.setState(
            {
                prevTime: moment(this.state.selectedTime).subtract(1, 'month').startOf('month').valueOf(),
                nextTime: moment(this.state.selectedTime).add(1, 'month').startOf('month').valueOf()
            }
        )
    }

    componentWillUnmount() {
        // window.$('.rw-container').css('top', null);
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    componentDidUpdate(prevProps) {
        if(this.props.selectedTime !== prevProps.selectedTime){
            this.setState(
                {
                    selectedTime: this.props.selectedTime
                }
            )
        }

        if(this.props.prevTime !== prevProps.prevTime){
            this.setState(
                {
                    prevTime: this.props.prevTime
                }
            )
        }

        if(this.props.nextTime !== prevProps.nextTime){
            this.setState(
                {
                    nextTime: this.props.nextTime
                }
            )
        }
    }

    renderAsOnText(txt){
        if(txt){
            return(
                <span className="countedDays">
                    ( {txt} )
                </span>
            )
        }
        
    }

    renderNextMonth(){
        if(this.state.nextTime > moment().startOf('month').valueOf()){
            return(
                <div className="next-time disabled">
                    <div className="txtContainer">
                        <span className="month">
                            { moment(this.state.nextTime).format('MMM') }
                        </span>
                        
                        <span className="year">
                            {moment(this.state.nextTime).format('YYYY')}
                        </span>
                        {this.renderAsOnText(this.props.nextAsOnCount)}
                        
                    </div>
                    
                    <div className="imgContainer">
                        <img src={rightArrow} />
                    </div>
                </div>
            )
        }
        else{
            return(
                <div className="next-time">
                    <div className="txtContainer" onClick={() => {this.props.updateSelectedTime(moment(this.state.selectedTime).add(1, 'month').startOf('month').valueOf())}}>
                        <span className="month">
                            { moment(this.state.nextTime).format('MMM') }
                        </span>
                        
                        <span className="year">
                            {moment(this.state.nextTime).format('YYYY')}
                        </span>
                        {this.renderAsOnText(this.props.nextAsOnCount)}
                    </div>
                    
                    <div className="imgContainer" onClick={() => {this.props.updateSelectedTime(moment(this.state.selectedTime).add(1, 'month').startOf('month').valueOf())}}>
                        <img src={rightArrow} />
                    </div>
                </div>
            )
        }
    }

    render(){
        return(
            <div className='timeLineContainer'>
                <div className="prev-time">
                    <div className="imgContainer" onClick={() => {this.props.updateSelectedTime(moment(this.state.selectedTime).subtract(1, 'month').startOf('month').valueOf())}}>
                        <img src={leftArrow} />
                    </div>
                    <div className="txtContainer" onClick={() => {this.props.updateSelectedTime(moment(this.state.selectedTime).subtract(1, 'month').startOf('month').valueOf())}}>
                        <span className="month">
                            {moment(this.state.prevTime).format('MMM')}
                        </span>
                        
                        <span className="year">
                            {moment(this.state.prevTime).format('YYYY')}
                        </span>
                    </div>
                    
                </div>
                <div className="current-time">
                    <div className="txtContainer">
                        <span className="month">
                            {moment(this.state.selectedTime).format('MMM')}
                        </span>
                        <span className="year">
                            {moment(this.state.selectedTime).format('YYYY')}
                        </span>
                        {this.renderAsOnText(this.props.selectedAsOnCount)}
                    </div>
                    
                </div>
                {this.renderNextMonth()}
            </div>
        )
    }
}

export default TimeLine;